import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: true,
  selector: 'dcc-download-csv-button',
  templateUrl: './download-csv-button.component.html',
  styleUrls: ['../buttons.scss'],
})
export class DownloadCsvButtonComponent {
  @Input() disabled = false;
  @Input() loading = false;

  @Output() download: EventEmitter<void> = new EventEmitter();

  onClick() {
    this.download.emit();
  }
}
